import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import { useResizeObserver } from 'owa-react-hooks/lib/useResizeObserver';
import { trackCanvasBounds } from '../viewstate';
import TimeStreamDocumentLayer from './TimeStreamDocumentLayer';

export default observer(function TimeStreamCanvasDocumentLayer() {
    const ref = React.useRef<HTMLDivElement>(null);
    useResizeObserver(ref, () => {
        trackCanvasBounds(ref.current!.getBoundingClientRect());
    });

    // Do not render the document layer on the first render cycle,
    // in order to avoid seeing the assets move across the screen
    // while CSS animates the document surface 'translate' property.
    const [showDocument, setShowDocument] = React.useState(false);
    React.useEffect(() => {
        setShowDocument(true);
    }, []);

    return (
        <div ref={ref} className={styles.canvasDocumentBody}>
            {showDocument && <TimeStreamDocumentLayer />}
        </div>
    );
});
